import http from "@/utils/http";


export const VisitorTypeApi = {

    getVisitorTypePage(params) {
        return http.get(`/server/visitor/type/page`,params)
    },
    getVisitorTypeList(params) {
        return http.get(`/server/visitor/type/list`,params)
    },
    save(data){
        return http.post(`/server/visitor/type/save`,data)
    },
    deleteById(id) {
        return http.get(`server/visitor/type/delete/${id}`)
    },
}